import { Outlet } from 'react-router-dom';
import { Sidebar } from '@/components/common/Sidebar';
import { Navbar } from '@/components/common/Navbar';

/**
 * Customer portal shell.
 * Phase 2 mounts wallet, referrals, binary tree, plans, cashback pages inside <Outlet />.
 */
export function CustomerLayout() {
  return (
    <div className="glow-field flex min-h-svh">
      <Sidebar variant="customer" />
      <div className="flex flex-1 flex-col">
        <Navbar variant="app" appNav="customer" />
        <main className="flex-1 p-6 lg:p-10">
          <div className="mx-auto w-full max-w-6xl">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
